import { Component, OnInit, ViewChild } from '@angular/core';
import { Account } from '../models/account';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-screenings',
  templateUrl: './screenings.component.html',
  styleUrls: ['./screenings.component.css']
})
export class ScreeningsComponent implements OnInit {

  accounts: Account[];
  isAccountSelected = false;
  foruscareService: ForuscareService;
  accountId = null;
  screeningCenterList = [];
  dropdownSettings: any = {};
  startDate = new Date().toISOString().slice(0, 10);
  endDate = new Date().toISOString().slice(0, 10);
  eventsList = [];
  createdEventId = null;
  screeningCenterListWithOrgIdAndOrgName = {};
  qrCodeUrl;
  totalEventsCount = 0;
  page = 1;
  days = [];
  hours = [];
  minutes = [];

  listing = true;
  selectedEvent: any;
  enableGenerateLinkButton: boolean = false;;

  constructor(public accountService: AccountService, private sanitizer: DomSanitizer) {
    this.foruscareService = new ForuscareService();
  }

  ngOnInit(): void {
    this.getAvailableAccounts();
    this.qrCodeUrl = (this.foruscareService.qrCodeUrl);
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.addNotificationTimings();


  }


  // To get the all available account list
  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            if (response.data.length > 0) {

              response.data.unshift({
                accountName: 'Select Account',
                accountId: 0
              });
            }
            this.accounts = response.data;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  // To get all the screening centers list by accountId tagged with account 
  getScreeningCenterListByAccountId() {
    this.screeningCenterList = [];
    if (this.accountId != null && this.accountId > 0) {
      this.accountService.screeningCentersByAccount(this.accountId)
        .subscribe(response => {
          if (response.errorCode == 200 && response.data && response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.screeningCenterListWithOrgIdAndOrgName[response.data[i].orgId] = response.data[i].orgName;
            }
            for (let i = 0; i < response.data.length; i++) {
              this.screeningCenterList.push({ id: response.data[i].orgId, itemName: response.data[i].orgName })
            }
            this.getScreeningEventsByAccountId(0);
          } else {
            this.eventsList = [];
          }
        },
          error => { });
    }
  }

  // To get all the screening events by accountId and orgIds
  getScreeningEventsByAccountId(offset: any) {
    let limit = 10;
    if (this.accountId) {
      this.accountService.getScreeningEvents({ "accountId": this.accountId }, limit, offset)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            // limit = response.data.totalCount;
            // this.accountService.getScreeningEvents({ "accountId": this.accountId }, limit, offset)

            this.isAccountSelected = true;

            if (response.data != null && response.data.events && response.data.events.length > 0) {
              for (let i = 0; i < response.data.events.length; i++) {
                let tempOrgIdStore = [];
                let orgIdArr = response.data.events[i].orgId ? response.data.events[i].orgId : [];
                for (let j = 0; j < orgIdArr.length; j++) {

                  tempOrgIdStore.push({ id: orgIdArr[j].toString(), itemName: this.screeningCenterListWithOrgIdAndOrgName[orgIdArr[j]] })
                }
                response.data.events[i].orgId = tempOrgIdStore;
              }
              this.totalEventsCount = response.data.totalCount;
              this.eventsList = response.data.events;

              //  Loop for Reminder alerts 
              for (let i = 0; i < response.data.events.length; i++) {
                let tempStore = [];
                let tempRemindersAlerts = response.data.events[i].reminderAlerts;
                if (tempRemindersAlerts && tempRemindersAlerts.length > 0) {
                  for (let j = 0; j < tempRemindersAlerts.length; j++) {
                    let getReminderFromattedTime = this.convetDateAndTimeToDaysHoursMinuteFormat(tempRemindersAlerts[j].days, tempRemindersAlerts[j].hours, tempRemindersAlerts[j].minutes);
                    tempStore.push({ id: (tempRemindersAlerts[j].days < 10 ? "0" + tempRemindersAlerts[j].days : tempRemindersAlerts[j].days) + ":" + (tempRemindersAlerts[j].hours < 10 ? "0" + tempRemindersAlerts[j].hours : tempRemindersAlerts[j].hours) + ":" + (tempRemindersAlerts[j].minutes < 10 ? "0" + tempRemindersAlerts[j].minutes : tempRemindersAlerts[j].minutes), itemName: getReminderFromattedTime })
                  }
                  response.data.events[i].reminderAlerts = tempStore;
                }
              }
            } else {
              this.eventsList = [];
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
  }

  getScreeningCentersAndScreningEvents() {
    this.getScreeningCenterListByAccountId();
    //this.getScreeningEventsByAccountId(0);
    this.isAccountSelected = true;
    if (this.accountId == 0 || this.accountId == null) {
      this.isAccountSelected = false;
    }
  }

  generateInviteLink(eventDetailsGenerateLink) {
    if (!eventDetailsGenerateLink.id && !this.createdEventId) {
      this.foruscareService.showNotification("Create or Upadate event first", "danger");
      return;
    }
    this.createdEventId = this.createdEventId ? this.createdEventId : eventDetailsGenerateLink.id;
    this.accountService.generateScreeeningEventInviteLink({ "id": this.createdEventId })
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data) {
            this.foruscareService.showNotification("Invite link generated successfully", "success");
            this.getScreeningEventsByAccountId(0);
            this.selectedEvent.inviteLink = response.data.inviteLink;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  sanitizeAmount(): void {
    if (this.selectedEvent.amount < 0) {
      this.selectedEvent.amount = null;
    }
  }

  validateDomain(emails: string): boolean {
    if (emails) {
      const domains = emails.split(',').map(domain => domain.trim());

      const domainRegex = /^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      for (const domain of domains) {
        if (!domainRegex.test(domain)) {
          return false;
        }
      }
      return true;
    } else {
      return true;
    }

  }

  createOrUpdateInviteLinkByAccountIdAndOrgId(eventData) {
    this.enableGenerateLinkButton = true;

    if (!eventData.eventName) {
      this.foruscareService.showNotification("Please enter screening event name", "danger");
      return;
    }

    if (!this.validateDomain(eventData.emailDomain) || !this.validateDomain(eventData.restrictedDomains)) {
      this.foruscareService.showNotification("Please enter the correct email domain(s)", "danger");
      return;
    }

    let orgIdPaylodLength = eventData.orgId.length;
    let payloadOrgId = []
    if (orgIdPaylodLength > 0) {
      for (let i = 0; i < orgIdPaylodLength; i++) {
        payloadOrgId.push(eventData.orgId[i].id);
      }
    } else {
      this.foruscareService.showNotification("Please select screening center", "danger");
      return;
    }
    let startDate = new Date(eventData.eventStartDate);
    let endDate = new Date(eventData.eventEndDate);
    if (startDate > endDate) {
      this.foruscareService.showNotification("Start date should not greater than end date", "danger");
      return;
    }
    eventData.enablePayment ? null : eventData.amount = null;
    if (eventData.enablePayment && (eventData.amount == null || eventData.amount == 0)) {
      this.foruscareService.showNotification("Please enter the correct amount.", "danger");
      return;
    }
    let reminderArr = [];
    if (eventData.reminderAlerts && eventData.reminderAlerts.length > 0) {
      for (let i = 0; i < eventData.reminderAlerts.length; i++) {
        let reminderSplittedArr = eventData.reminderAlerts[i].id.split(":");
        reminderArr.push({ days: parseInt(reminderSplittedArr[0]), hours: reminderSplittedArr[1], minutes: reminderSplittedArr[2] })
      }
    }
    let payload = {
      id: eventData.id,
      accountId: eventData.accountId,
      eventStartDate: eventData.eventStartDate,
      eventEndDate: eventData.eventEndDate,
      orgId: payloadOrgId,
      emailDomain: eventData.emailDomain,
      restrictedDomains: eventData.restrictedDomains,
      minutesBeforeToReschedule: parseInt(eventData.minutesBeforeToReschedule),
      reminderAlerts: reminderArr,
      eventName: eventData.eventName,
      enablePayment: eventData.enablePayment,
      amount: eventData.amount
    }
    this.accountService.createOrUpdateScreeningEvent(payload)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          this.createdEventId = response.data.id;
          eventData.id = this.createdEventId;
          this.foruscareService.showNotification("Screening event creation/updation successfully", "success");
          this.getScreeningEventsByAccountId(0);
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  // Below function is used to copy the link(url) 
  copyInviteLinkHandler(eventData) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = eventData.inviteLink;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.foruscareService.showNotification("Invite link copied successfully", "success");
  }


  setEventStatus(eventDetails) {
    if (!eventDetails.id) {
      this.foruscareService.showNotification("First create event", "danger");
      return;
    }
    let payload = { id: eventDetails.id, status: eventDetails.status }
    this.accountService.enableDisableEvent(payload)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data.status) {
            this.foruscareService.showNotification("Event enabled successfully", "success");
          } else {
            this.foruscareService.showNotification("Event disabled successfully", "success");
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  onTableDataChange(pageNumber) {
    this.page = pageNumber;
    this.getScreeningEventsByAccountId((pageNumber - 1) * 10);

  }


  addNotificationTimings() {
    // For Days
    for (let i = 0; i <= 31; i++) {
      this.days.push({ id: i, itemName: i });
    }

    // For Hours
    for (let i = 0; i <= 24; i++) {
      this.hours.push({ id: i, itemName: i });
    }
    // For Minutes
    for (let i = 0; i <= 60; i++) {
      this.minutes.push({ id: i, itemName: i });
    }
  }

  addReminders(item) {
    let reminderAlertsId = ((item.selectedDay ? (item.selectedDay <= 9 ? "0" + item.selectedDay : item.selectedDay) + ":" : "00:") + (item.selectedHour ? (item.selectedHour <= 9 ? "0" + item.selectedHour : item.selectedHour) + ":" : "00:") + (item.selectedMinute ? (item.selectedMinute <= 9 ? "0" + item.selectedMinute : item.selectedMinute) : "00"));

    if (item.reminderAlerts && item.reminderAlerts.length > 0) {

      for (let i = 0; i < item.reminderAlerts.length; i++) {
        if (item.reminderAlerts[i].id == reminderAlertsId) {
          this.foruscareService.showNotification("This reminder is already present", "danger");
          return;
        }
      }
    }

    item.reminderAlerts.push({ id: reminderAlertsId, itemName: this.convetDateAndTimeToDaysHoursMinuteFormat(item.selectedDay, item.selectedHour, item.selectedMinute) })
    item.selectedDay = null;
    item.selectedHour = null;
    item.selectedMinute = null;
  }
  deleteItem(event, item) {
    const index = event.reminderAlerts.indexOf(item);
    if (index !== -1 && event.status) {
      event.reminderAlerts.splice(index, 1);
    }
  }

  convetDateAndTimeToDaysHoursMinuteFormat(days, hours, minutes) {
    days = Number(days);
    hours = Number(hours);
    minutes = Number(minutes);
    let arrItem = (days ? (days <= 9 ? "0" + days : days) + " Days:" : "00 Days:") + (hours ? (hours <= 9 ? "0" + hours : hours) + " Hours:" : "00 Hours:") + (minutes ? (minutes <= 9 ? "0" + minutes : minutes) + " Minutes" : "00 Minutes");
    return arrItem;
  }

  toggleView() {
    this.listing = !this.listing;
    if (!this.listing) {
      this.addNewEvent();
      // this.selectedEvent = this.eventsList[0];
    };
  }


  addNewEvent() {
    // this.eventsList.unshift({ id: null, eventStartDate: new Date().toISOString().slice(0, 10), eventEndDate: new Date().toISOString().slice(0, 10), orgId: [], accountId: this.accountId, status: true, emailDomain: null, restrictedDomains: null, minutesBeforeToReschedule: null, reminderAlerts: [], selectedDay: null, selectedHour: null, selectedMinute: null })
    this.selectedEvent =
    {
      id: null,
      eventStartDate: new Date().toISOString().slice(0, 10),
      eventEndDate: new Date().toISOString().slice(0, 10),
      orgId: [],
      accountId: this.accountId,
      status: true,
      emailDomain: null,
      restrictedDomains: null,
      minutesBeforeToReschedule: null,
      reminderAlerts: [],
      selectedDay: null,
      selectedHour: null,
      selectedMinute: null,
      eventName: null,
      enablePayment: false,
      amount: null
    };
  }

  editEvent(event: any) {
    this.enableGenerateLinkButton = false;
    this.selectedEvent = event;
    this.listing = !this.listing;
  }

}
